export default "__VITE_ASSET__Bwwd9NDZ__"